import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {UserService} from "../../../services/user-services/user.service";
import {HelperService} from "../../../services/helper.service";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {NgClass, NgFor, NgIf, NgStyle} from '@angular/common';
import {PlatformService} from "../../../services/platform-service.service";
import {ProcessSharedService} from "../../../services/process-shared.service";
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-article-card',
    templateUrl: './article-card.component.html',
    styleUrls: ['./article-card.component.scss'],
    standalone: true,
    imports: [NgIf, NgClass, NgFor, NgStyle, TranslateModule, DatePipe]
})
export class ArticleCardComponent implements OnInit {
  @Input() public articles;
  @Input() public type_page;
  @Input() public isLastArticle;
  @Input() public isFeaturedArticles;
  @Input() public isLatestArticles;
  @Input() public isSimilarArticles;
  @Input() public index;
  @Input() public lang;


  public title;
  isAtStart = true;
  isAtEnd = false;
  isMobile;
  isServer = false;
  agentList: any;

  constructor(
    private router: Router,
    private userService: UserService,
    private helperService: HelperService,
    private translate: TranslateService,
    private platformService : PlatformService,
    private processSharedService: ProcessSharedService
  ) {
    this.isMobile = this.userService.isMobileUser;
    this.isServer = this.platformService.isServerPlatform();
  }

  ngOnInit(): void {
    this.getAgentList();
    if (this.isFeaturedArticles) {
      this.title =  'COMMON.BLOG.FEATURED_ARTICLE';
    }
    else if (this.isLatestArticles) {
      this.title =  'COMMON.BLOG.LAST_ARTICLE';
    }
    else if (this.isSimilarArticles) {
      this.title =  'COMMON.BLOG.SIMILAR_ARTICLE';
    }
  }

  ngAfterViewInit() {
    if(this.platformService.isBrowserPlatform()){
      const lazyImages = document.querySelectorAll('.lazybg');
      lazyImages.forEach((image) => {
        image.classList.remove('lazybg');
      });
    }
  }

  public goTo(article): void {
    if(article.type == 'article'){
      window.open(this.router.serializeUrl(this.router.createUrlTree([article.type + '/' + article.slug])), '_blank', 'noopener,noreferrer');
    }
    else {
      window.open(this.router.serializeUrl(this.router.createUrlTree([this.lang + '/' + article.type + '/' + article.slug])), '_blank', 'noopener,noreferrer');
    }

  }

  public firstTag(article): { text: string, icon?: string } | false {
    try {
        let tags = JSON.parse(article.tags);
        if (tags && tags.length > 0) {
            const firstTag = tags[0];
            const capitalizedTag = firstTag.charAt(0).toUpperCase() + firstTag.slice(1);
            
            return {
                text: capitalizedTag,
                icon: article.tagIcon
            };
        }
        return false;
    } catch (error) {
        console.error('Error parsing tags:', error);
        return false;
    }
}

  public firstParagraph(description){
    let parser = new DOMParser();
    let doc = parser.parseFromString(description, 'text/html');
    let firstParagraph = doc.querySelector('p');
    return firstParagraph ? firstParagraph.textContent.trim() : description;
  }
  getAgentList(){
    this.processSharedService.getAgents().subscribe((data: any) => {
      this.agentList = data;
  });

}
getAgentInfo(agentId: number): any {
 let agent = this.agentList.find(agent => agent.id === agentId);
 return agent;
}
getAgentAvatar(agentId: number): any {
  let agent = this.agentList.find(agent => agent.id === agentId);
  const img = agent.firstname.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return '/assets/img/admin/agents/' + img.toLowerCase() + '.webp';
}

}
